module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['BaseTabs', _vm.className]
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: item.id,
      class: ['BaseTabs__item', item.id == _vm.value ? 'BaseTabs__item_selected' : ''],
      on: {
        "click": function($event) {
          _vm.change(item.id)
        }
      }
    }, [_vm._v("\n        " + _vm._s(_vm.translate(item.name)) + "\n    ")])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3eb2da92"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseTabs.vue
// module id = 536
// module chunks = 1